document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll('.accordion-collapse');

  accordionItems.forEach((item) => {
    item.addEventListener('show.bs.collapse', function () {
      const button = this.previousElementSibling.querySelector('.accordion-button');
      const iconPlus = button.querySelector('.icon-plus');
      const iconMinus = button.querySelector('.icon-minus');

      iconPlus.classList.add('d-none');
      iconMinus.classList.remove('d-none');
    });

    item.addEventListener('hide.bs.collapse', function () {
      const button = this.previousElementSibling.querySelector('.accordion-button');
      const iconPlus = button.querySelector('.icon-plus');
      const iconMinus = button.querySelector('.icon-minus');

      iconPlus.classList.remove('d-none');
      iconMinus.classList.add('d-none');
    });
  });
});
